// @flow

import * as React from 'react';

type Props = {| title: string |};
export default function DocumentTitle({ title }: Props) {
  React.useEffect(() => {
    document.title = title;
  }, [title]);
  return null;
}
